import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items, light = false }: { items: Crumb[]; light?: boolean }) {
  return (
    <nav
      aria-label="面包屑导航"
      className={`flex flex-wrap items-center gap-2 text-sm ${light ? "text-white/70" : "text-foreground-500"}`}
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={`${item.label}-${index}`} className="flex items-center gap-2">
            {item.to && !isLast ? (
              <Link
                to={item.to}
                className={`cursor-pointer ${light ? "hover:text-primary-200" : "hover:text-primary-600"}`}
              >
                {item.label}
              </Link>
            ) : (
              <span
                className={
                  isLast
                    ? light
                      ? "text-white"
                      : "text-foreground-800"
                    : ""
                }
              >
                {item.label}
              </span>
            )}
            {!isLast && (
              <i
                className={`ri-arrow-right-s-line text-base ${light ? "text-white/40" : "text-foreground-300"}`}
              ></i>
            )}
          </span>
        );
      })}
    </nav>
  );
}